import { useRef, useEffect } from 'react'
import { useThreeScene } from '@/hooks/useThreeScene'
import { BreathingState } from '@/types/breathing'

interface BreathingCanvasProps {
  breathingState: BreathingState
  isActive: boolean
}

export function BreathingCanvas({ breathingState, isActive }: BreathingCanvasProps) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const { initThreeScene, updateFlower, startRenderLoop, stopRenderLoop, cleanup, handleResize } = useThreeScene(canvasRef)

  useEffect(() => {
    if (isActive && canvasRef.current) {
      console.log('Initializing Three.js scene...')
      const cleanupFn = initThreeScene()
      
      // Start the render loop after a short delay to ensure scene is ready
      setTimeout(() => {
        startRenderLoop()
      }, 100)
      
      return () => {
        stopRenderLoop()
        cleanupFn?.()
        cleanup()
      }
    }
  }, [isActive, initThreeScene, startRenderLoop, stopRenderLoop, cleanup])

  useEffect(() => {
    if (isActive) {
      updateFlower(breathingState.cycleProgress, breathingState.isInhaling)
    }
  }, [isActive, breathingState, updateFlower])

  // Handle canvas resize with ResizeObserver
  useEffect(() => {
    if (!isActive || !canvasRef.current || !handleResize) return

    // const canvas = canvasRef.current
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect
        if (width > 0 && height > 0) {
          handleResize({
            width,
            height
          })
        }
      }
    })

    resizeObserver.observe(window.document.body)

    // setInterval(() => {
    //   handleResize()
    // }, 1000)

    return () => {
      resizeObserver.disconnect()
    }
  }, [isActive, handleResize])

  if (!isActive) {
    return null
  }

  return (
    <canvas
      ref={canvasRef}
      className="breathing-canvas"
    />
  )
}
